module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-05-1cb5c3cd1485dddd0e5e81e5b208d237.jpg";